import { Box, Typography, Tooltip, IconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

const CopyableText = ({ text, iconPosition = 'right', linkTo = null }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const icon = (
        <Tooltip title={copied ? 'הועתק!' : 'העתק'}>
            <IconButton size="small" onClick={handleCopy} sx={{ mx: 1 }}>
                <ContentCopyIcon fontSize="small" />
            </IconButton>
        </Tooltip>
    );

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {iconPosition === 'left' && icon}
            {linkTo ? (
                <Typography
                    variant="body2"
                    color="primary"
                    component={RouterLink}
                    to={linkTo}
                >
                    {text}
                </Typography>
            ) : (
                <Typography variant="body2" color="text.secondary">
                    {text}
                </Typography>
            )}
            {iconPosition === 'right' && icon}
        </Box>
    );
};

export default CopyableText;
